export const COMPLETE_ACCOUNT_FAIL = 'la/ui/completeAccount/FAIL';
export const COMPLETE_ACCOUNT_REQUEST = 'la/ui/completeAccount/REQUEST';
export const COMPLETE_ACCOUNT_SUCCESS = 'la/ui/completeAccount/SUCCESS';
